import moment from "moment";

export enum ESubtractType {
    seconds = 'seconds',
    minutes = 'minutes',
    hours = 'hours',
    days = 'days',
    weeks = 'weeks',
    months = 'months',
    years = 'years',
}

export const availableDateFormats = [
    'YYYY-MM-DDTHH:mm:ss',
    'DD/MM/YYYY, HH:mm',
    'DD-MMM-YY',
    'MMM-DD-YY',
    'YYYY-MM-DD',
    'MMMM Do YYYY',
    'MMM Do YY',
    'LL',
    'L',
];

export const dateFormat = {
    vn: 'DD/MM/YYYY',
    en: 'MM/DD/YYYY'
};

export const timeFormat = [
    'L', //MM/DD/YY
    'LT', //HH:mm
    'LTS' //HH:mm:ss
];
